import { jsx as _jsx } from "react/jsx-runtime";
export function PRstatus(param) {
    var statusID = param.statusID, statusName = param.statusName;
    var color = "";
    var bg = "";
    if (statusID === 1) {
        color = "#FDB428";
        bg = "rgba(255, 246, 229, 1)";
    } else if (statusID === 2) {
        color = "#FF731D";
        bg = "rgba(255, 115, 29, 0.15)";
    } else if (statusID === 3) {
        color = "rgba(114, 225, 40, 0.87)";
        bg = "rgba(238, 251, 229, 1)";
    } else if (statusID === 6) {
        color = "#747474";
        bg = "#F4F4F4";
    } else {
        color = "rgba(249, 80, 87, 1)";
        bg = "rgba(255, 0, 0, 0.15)";
    }
    return statusID ? /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 mx-auto",
        style: {
            color: color,
            backgroundColor: bg,
            borderRadius: "20px"
        },
        children: statusName
    }) : /*#__PURE__*/ _jsx("div", {
        children: "-"
    });
}
